<template>
  <div class="overflow-hidden h-100">
    <div v-show="currentJob.state === 'completed'" class="h-100">
      <div class="gallery-1 justify-content-center pb-20 h-100">
        <div v-for="output in currentJob.base64_output_images" class="image h-100"><img :src="output"></div>
      </div>
    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import currentJob from './../../mixins/current_job.mixin'

export default {
  name: "JobCanvas",
  props: {},
  components: {},
  mixins: [
    store,
    currentJob,
  ],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {},
  computed: {
    loadingImage() {
      //return AspectRatioManager.getAspectRatioByWidthHeight(this.currentJob.settings.conversion.options.width, this.currentJob.settings.conversion.options.height).loading;
    }
  }
};
</script>
<style lang="scss" scoped>
.gallery-1 {
  display: flex;
  gap: 20px;

  img {
    object-fit: contain;
    object-position: top;
    height: 100%;
    width: 100%;
    padding-bottom: 20px;
  }
}

.image {
  object-fit: contain;
  object-position: top;
  display: flex;
  justify-content: center;
}

.loading .image,
.loading h4,
.loading .description {
  background-color: #383838;
  background: linear-gradient(
          100deg,
          rgba(255, 255, 255, 0) 40%,
          rgba(255, 255, 255, .1) 50%,
          rgba(255, 255, 255, 0) 60%
  ) #383838;
  background-size: 200% 100%;
  background-position-x: 180%;
  animation: 1s loading ease-in-out infinite;


}

@keyframes loading {
  to {
    background-position-x: -20%;
  }
}
</style>
